export const RANGE_STATES = {
  ABOVE: 'above',
  BELOW: 'below',
  BETWEEN: 'between',
} as const;

export type RangeState = (typeof RANGE_STATES)[keyof typeof RANGE_STATES];
